var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"main"},[_c('transition',{attrs:{"name":"scale-fade"}},[(_vm.ready)?_c('img',{staticClass:"countdown-img",attrs:{"src":_vm.imgSrc,"alt":"countdown"}}):_vm._e()]),_vm._v(" "),_c('audio',{ref:"audio",attrs:{"src":require("../../assets/audio/countdown.mp3")}},[_vm._v("浏览器版本过低，请尽快升级")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b949508","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href","audio":"src"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Countdown/index.vue
// module id = null
// module chunks = 